import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { Button } from 'vant'
import { getUrlQuery } from './utils/getUrlQuery'

const app = createApp(App)

router.beforeEach(() => {
  const lang = getUrlQuery('lang')
  let title = 'Online Service'
  if (lang === 'cn') {
    title = '在线客服'
  }
  switch (lang) {
    case 'cn':
      title = '在线客服'
      break
    case 'en':
      title = 'Online Service'
      break
    default:
      break
  }
  document.title = title
})

app.use(router).use(i18n).use(Button).mount('#app')
